import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 12/14;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M61.523 16.329a.777.777 0 1 0-1.1-1.1l-2.194 2.195a.775.775 0 0 0-.229.551c-.001.2.074.398.227.55l2.197 2.198a.777.777 0 1 0 1.1-1.1l-.87-.87h9.775a.778.778 0 0 0 0-1.555h-9.775l.87-.87zm-1.98 7.09a.776.776 0 0 0-.777.778c0 .432.348.777.778.777h9.802l-.87.87a.777.777 0 1 0 1.1 1.1l2.197-2.198a.768.768 0 0 0 .227-.55.775.775 0 0 0-.23-.552l-2.194-2.194a.777.777 0 1 0-1.1 1.1l.87.87h-9.802z" transform="translate(-58 -15)" fill={color} fillRule="evenodd" />
    </svg>
)

export default class IconTransfer extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
